module.exports = __webpack_public_path__ + "media/images/pic/news-main-2b2ad0216a440f21b25b608b93dc205c.svg";